import { Component } from '@angular/core'
import { Router } from '@angular/router'

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent {
    message: string | undefined = undefined
    code: number | undefined = undefined

    constructor(private readonly router: Router) {
        this.message = this.router.getCurrentNavigation()?.extras?.state?.errorMessage
        this.code = this.router.getCurrentNavigation()?.extras?.state?.errorCode
    }

    goToHome(): void {
        this.router.navigate(['/cases'])
    }
}
